import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare var $: any;
import { debounceTime } from "rxjs/operators";
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { emailPattern, mobilePattern, noWhitespaceInRequiredValidator } from '../../shared/constants';
/* import { SignaturePadComponent } from '@almothafar/angular-signature-pad'; */
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

@Component({
	selector: 'app-fleet-create',
	templateUrl: './fleet-create.component.html',
	styleUrl: './fleet-create.component.css'
})
export class FleetCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		/* {
			path: '/app/dashboard-mdm',
			name: "MDM"
		}, */
		{
			path: "/app/fleet",
			name: "Fleets"
		}
	];
	uId: any = null;
	pagetitle = "Create Fleet";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	showDeleteLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	countries: any = [];
	companyList: any = [];
	pocList: any = [];
	formSubmitted: boolean = false;
	user_type: any = "";
	accessLoader = false;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe((data: any) => {
			this.accessLoader = false;
			try {
				this.user_type = data.res[0].user_type;
				/* let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
				this.UserModuleAccess = accessObj["USER_Module"]; */
			} catch (error) { }
		}, (error: any) => {
			this.accessLoader = false;
			/* this.UserModuleAccess = "NoAccess"; */
		});
	}
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				company_master: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				EmailId: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
				country_code: [null/* , [Validators.required, noWhitespaceInRequiredValidator] */],
				contact_no: [null/* , [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)] */],
				contact_person: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				address: [null, [Validators.required, noWhitespaceInRequiredValidator]]
			})
			this.getCountryCodes();
			this.getCompanyList();
			this.getPOCList();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-fleet/" + this.uId, name: "Edit Fleet" });
				this.pagetitle = "Edit Fleet";
				this.pageLoading = true;
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-fleet", name: "Add Fleet" });
				this.pageLoading = true;
			}
		});
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	showError(field:string){
		if(this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)){
			return true;
		}
		return false;
	}

	getDetails() {
		this.apiService.getFleetDetails({ "id": this.uId }).subscribe((data: any) => {
			this.details = data.data;
			this.f.company_master.setValue(this.details.company_master?this.details.company_master.id:null);
			this.f.name.setValue(this.details.name);
			this.f.EmailId.setValue(this.details.EmailId);
			this.f.country_code.setValue(this.details.country_code);
			this.f.contact_no.setValue(this.details.contact_no);
			this.f.address.setValue(this.details.address);
			let contact_person:any;
			try {
				contact_person = JSON.parse(this.details.contact_person);
			} catch (error) {
				contact_person = [];
			}
			this.f.contact_person.setValue(contact_person);
		}, (error) => {
			this.pageLoading = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to fetch details.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe((data: any) => {
			data.map((c: any) => {
				c.display = c.dial_code + "(" + c.name + ")"
				return c;
			})
			this.countries = data;
		}, (error) => {
			this.countries = [];
		});
	}

	getCompanyList() {
		this.apiService.getCompanyDetails({}).subscribe((data: any) => {
			this.companyList = data.data;
		}, (error) => {
			this.companyList = [];
		});
	}

	getPOCList() {
		this.apiService.getPocDetails({}).subscribe((data: any) => {
			data.data.map((person:any)=>{
				try {
					person.full_name = person.f_name + " " + person.l_name;
				} catch (error) {
					person.full_name = person.f_name;
				}
				return person;
			})
			this.pocList = data.data;
		}, (error) => {
			this.pocList = [];
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let contact_person:any;
		try {
			contact_person = JSON.stringify(this.f.contact_person.value)
		} catch (error) {
			contact_person = JSON.stringify([])
		}
		let payload: any = {
			name: this.f.name.value,
			company_master: this.f.company_master.value,
			EmailId: this.f.EmailId.value,
			country_code: this.f.country_code.value,
			contact_no: this.f.contact_no.value,
			address: this.f.address.value,
			contact_person: contact_person,
		};

		if (this.uId) {
			payload["id"] = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateFleet(payload).subscribe(data => {
			this.showLoader = false;
			this.toastr.success("Saved successfully.", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.gotoList();
		}, (error: any) => {
			this.showLoader = false;
			if (error.status == 401) { return }
			if (error.status == 409) {
				Swal.fire({
					title: 'Already Exists',
					html: 'Fleet already exists. Do you want to restore it?',
					icon: 'question',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: 'Yes, Restore!',
					cancelButtonText: 'Cancel',
					confirmButtonColor: '#3e4fb1'
				}).then((result) => {
					if (result.value) {
						this.apiService.restoreFleet(error.error.id).subscribe((data: any) => {
							this.toastr.success("Fleet restored successfully", 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.gotoList();
						}, (error) => {
							this.toastr.error("Something went wrong", 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						});
					} else if (result.dismiss === Swal.DismissReason.cancel) { }
				})
			} else {
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}

						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/fleet']);
	}
}
